/* abcoffee theme JS — Option B chrome behaviors + Option A section behaviors + real Shopify cart */
(function () {
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  /* ---------- loader: brief hold on the wordmark, never blocks long ---------- */
  const loader = qs('.page-loader');
  const LOADER_MIN = 500;
  const started = performance.now();
  const hideLoader = () => loader?.classList.add('is-gone');
  window.addEventListener('load', () => setTimeout(hideLoader, Math.max(50, LOADER_MIN - (performance.now() - started))));
  setTimeout(hideLoader, 2200);

  /* ---------- header: static, never hides on scroll ---------- */
  const header = qs('#site-header');
  if (header) {
    addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', scrollY > 30);
    }, { passive: true });
  }

  /* ---------- back to top ---------- */
  qsa('[data-back-to-top]').forEach(btn => btn.addEventListener('click', () => {
    scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }));

  /* ---------- mobile menu ---------- */
  const toggle = qs('.nav-toggle'), menu = qs('.mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('locked', open);
    });
  }

  /* ---------- route bar clock (IST) ---------- */
  const routeTime = qs('#routeTime');
  if (routeTime) {
    const setTime = () => {
      routeTime.textContent = new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Kolkata' }) + ' IST';
    };
    setTime();
    setInterval(setTime, 30000);
  }

  /* ---------- "ab." cursor ---------- */
  const cursor = qs('.cursor');
  if (cursor && matchMedia('(pointer:fine)').matches) {
    addEventListener('pointermove', e => {
      cursor.style.translate = `${e.clientX}px ${e.clientY}px`;
      cursor.classList.add('is-visible');
    });
    qsa('a,button,input,select,textarea').forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('is-hover'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('is-hover'));
    });
  }

  /* ---------- magnetic elements ---------- */
  qsa('.magnetic').forEach(el => {
    el.addEventListener('mousemove', e => {
      const r = el.getBoundingClientRect();
      el.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .12}px,${(e.clientY - r.top - r.height / 2) * .12}px)`;
    });
    el.addEventListener('mouseleave', () => el.style.transform = '');
  });

  /* ---------- reveals: B [data-reveal] + A .reveal ---------- */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in-view');
    io.unobserve(e.target);
  }), { threshold: .12 });
  qsa('[data-reveal]').forEach(el => io.observe(el));
  /* safety net: never leave content hidden if the observer misfires */
  setTimeout(() => qsa('[data-reveal]:not(.in-view)').forEach(el => {
    if (el.getBoundingClientRect().top < innerHeight) el.classList.add('in-view');
  }), 4000);

  /* ---------- home journey: sticky chapter cards ---------- */
  function setupJourneys(scope = document) {
    qsa('[data-journey]', scope).forEach(section => {
      if (section.dataset.journeyBound === 'true') return;
      section.dataset.journeyBound = 'true';
      const stack = qs('[data-journey-stack]', section);
      const cards = qsa('[data-journey-card]', section);
      if (!stack || !cards.length) return;

      const pace = parseFloat(section.dataset.journeyPace) || .78;
      stack.style.height = `${(cards.length * pace + 1) * 100}svh`;
      let queued = false;
      const render = () => {
        queued = false;
        const rect = stack.getBoundingClientRect();
        const total = Math.max(stack.offsetHeight - innerHeight, 1);
        const progress = Math.min(Math.max(-rect.top / total, 0), 1) * cards.length;
        cards.forEach((card, index) => {
          const local = Math.min(Math.max(progress - index, 0), 1);
          const y = (1 - Math.min(local * 1.6, 1)) * innerHeight;
          const parked = progress - index > 1;
          const scale = 1 - Math.max(0, Math.min((progress - index - 1) * .045, .15));
          const rotation = parked ? (index % 2 ? 1 : -1) * 1.1 : 0;
          card.style.transform = `translateY(${y}px) scale(${parked ? scale : 1}) rotate(${rotation}deg)`;
          card.style.zIndex = String(10 + index);
        });
      };
      const requestRender = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(render);
      };
      addEventListener('scroll', requestRender, { passive: true });
      addEventListener('resize', requestRender, { passive: true });
      render();
    });
  }
  setupJourneys();

  /* ---------- home app: phones spread when revealed ---------- */
  function setupAppPhones(scope = document) {
    qsa('[data-app-phones]', scope).forEach(phones => {
      if (phones.dataset.phonesBound === 'true') return;
      phones.dataset.phonesBound = 'true';
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        phones.classList.toggle('in-view', entry.isIntersecting);
      }), { threshold: .35 });
      observer.observe(phones);
    });
  }
  setupAppPhones();

  document.addEventListener('shopify:section:load', event => {
    setupJourneys(event.target);
    setupAppPhones(event.target);
  });

  /* ---------- counters: B [data-count] + A .count[data-to] ---------- */
  const cio = new IntersectionObserver(es => es.forEach(({ target, isIntersecting }) => {
    if (!isIntersecting) return;
    cio.unobserve(target);
    const end = +target.dataset.count, t0 = performance.now();
    const run = t => {
      const p = Math.min((t - t0) / 1300, 1);
      target.textContent = Math.round(end * (1 - Math.pow(1 - p, 4)));
      if (p < 1) requestAnimationFrame(run);
    };
    requestAnimationFrame(run);
  }), { threshold: .6 });
  qsa('[data-count]').forEach(el => cio.observe(el));


  /* ---------- tab filters (B [data-tabs]) ---------- */
  /* Tints are alternated over the cards a shopper can actually see: filtering
     hides cards, so a server-rendered odd/even pattern stops alternating. */
  const restripeMenu = () => qsa('.menu-grid').forEach(grid => {
    let i = 0;
    qsa('.menu-item', grid).forEach(card => {
      if (card.classList.contains('is-hidden')) return;
      const lime = i % 2 === 0;
      card.classList.toggle('menu-item--lime', lime);
      card.classList.toggle('menu-item--cream', !lime);
      i++;
    });
  });

  qsa('[data-tabs]').forEach(group => {
    const buttons = qsa('[data-tab]', group);
    const applyFilter = btn => {
      const filter = btn.dataset.tab;
      const target = group.dataset.target || 'body';
      qsa('[data-category]', qs(target) || document).forEach(card =>
        card.classList.toggle('is-hidden', filter !== 'all' && !card.dataset.category.split(' ').includes(filter)));
      restripeMenu();
    };
    buttons.forEach(btn => btn.addEventListener('click', () => {
      buttons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      applyFilter(btn);
    }));
    /* no "all" tab: apply the initially active category on load */
    const active = buttons.find(b => b.classList.contains('is-active'));
    if (active && active.dataset.tab !== 'all') applyFilter(active);
  });
  restripeMenu();

  /* ---------- step tabs (B [data-steps]) ---------- */
  qsa('[data-steps]').forEach(wrap => {
    const buttons = qsa('[data-step]', wrap);
    const panels = qsa('[data-step-panel]', wrap);
    const visuals = qsa('[data-step-visual]', wrap);
    const activate = index => {
      buttons.forEach((b, i) => { b.classList.toggle('is-active', i === index); b.setAttribute('aria-selected', String(i === index)); });
      panels.forEach((p, i) => { p.classList.toggle('is-active', i === index); p.hidden = i !== index; });
      visuals.forEach((v, i) => { v.classList.toggle('is-active', i === index); v.setAttribute('aria-hidden', String(i !== index)); });
    };
    buttons.forEach((button, index) => {
      button.addEventListener('mouseenter', () => activate(index));
      button.addEventListener('focus', () => activate(index));
      button.addEventListener('click', () => activate(index));
    });
    activate(Math.max(0, buttons.findIndex(b => b.classList.contains('is-active'))));
  });



  /* ---------- FAQ accordions ---------- */
  qsa('[data-accordion]').forEach(item => {
    const head = qs('[data-accordion-toggle]', item);
    head?.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      head.setAttribute('aria-expanded', String(open));
    });
  });


  /* ---------- product gallery: snap carousel with dots + arrows ---------- */
  qsa('.product-gallery').forEach(gal => {
    const items = qsa('.product-gallery__item', gal);
    if (items.length < 2) return;
    const host = gal.parentElement;
    if (host && getComputedStyle(host).position === 'static') host.style.position = 'relative';

    const dots = document.createElement('div');
    dots.className = 'pg-dots';
    items.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      b.addEventListener('click', () => gal.scrollTo({ left: gal.clientWidth * i, behavior: 'smooth' }));
      dots.appendChild(b);
    });
    const mk = (dir, label, glyph) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'pg-arrow pg-arrow--' + dir;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      b.addEventListener('click', () => gal.scrollBy({ left: gal.clientWidth * (dir === 'next' ? 1 : -1), behavior: 'smooth' }));
      return b;
    };
    const prev = mk('prev', 'Previous image', '←');
    const next = mk('next', 'Next image', '→');
    (host || gal).append(prev, next, dots);

    const sync = () => {
      const i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
      qsa('button', dots).forEach((d, n) => d.classList.toggle('is-active', n === i));
      prev.disabled = i <= 0;
      next.disabled = i >= items.length - 1;
    };
    gal.addEventListener('scroll', () => { cancelAnimationFrame(gal._pgRaf); gal._pgRaf = requestAnimationFrame(sync); }, { passive: true });
    sync();
  });

  /* ---------- partnership cards: only the clicked card expands ---------- */
  qsa('.cpar').forEach(root => {
    const cards = qsa('[data-cpar-card]', root);
    cards.forEach(card => card.addEventListener('click', e => {
      if (e.target.closest('a, button')) return;
      cards.forEach(c => { if (c !== card) c.classList.remove('is-open'); });
    }));
  });

  /* ---------- subscription cards: one benefits panel at a time ---------- */
  qsa('.subcards').forEach(root => {
    const accs = qsa('.subcards__benefits', root);
    if (!accs.length) return;
    const shut = acc => {
      acc.classList.remove('is-open');
      qs('[data-accordion-toggle]', acc)?.setAttribute('aria-expanded', 'false');
    };
    const closeAll = except => accs.forEach(a => { if (a !== except) shut(a); });
    const open = acc => {
      acc.classList.add('is-open');
      qs('[data-accordion-toggle]', acc)?.setAttribute('aria-expanded', 'true');
    };
    /* Hovering a card opens its benefits and closes every other one. Done in JS
       rather than a CSS :hover rule so it does not depend on the browser
       reporting a fine pointer. */
    accs.forEach(acc => {
      const card = acc.closest('.subcards__card') || acc;
      card.addEventListener('mouseenter', () => { closeAll(acc); open(acc); });
      card.addEventListener('mouseleave', () => shut(acc));
    });
    /* Touch: the generic accordion handler has already toggled this one open,
       so we only need to close the rest. */
    accs.forEach(acc => qs('[data-accordion-toggle]', acc)
      ?.addEventListener('click', () => closeAll(acc)));

    /* moving to another card collapses whatever was open */
    const track = qs('.subcards__track', root);
    const cards = qsa('.subcards__card', root);
    let last = cards.findIndex(c => c.classList.contains('is-active'));
    const check = () => {
      const now = cards.findIndex(c => c.classList.contains('is-active'));
      if (now !== last) { last = now; closeAll(null); }
    };
    track?.addEventListener('scroll', check, { passive: true });
    qsa('.subcards__arrow', root).forEach(b => b.addEventListener('click', () => closeAll(null)));
  });

  /* ---------- brand casing: "abcoffee" family stays lowercase in uppercase headings ---------- */
  const BRAND_RE = /(abcoffee|absub|abcircle|abapp)/gi;
  const BRAND_CANON = { abcoffee: 'abcoffee', absub: 'absub', abcircle: 'abcircle', abapp: 'abApp' };
  function brandCase(scope = document) {
    qsa('main h1, main h2, main h3, main h4', scope).forEach(h => {
      const walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        if (node.parentElement.closest('.brand-case')) return;
        BRAND_RE.lastIndex = 0;
        if (!BRAND_RE.test(node.nodeValue)) return;
        BRAND_RE.lastIndex = 0;
        const frag = document.createDocumentFragment();
        let last = 0, m;
        while ((m = BRAND_RE.exec(node.nodeValue))) {
          frag.append(node.nodeValue.slice(last, m.index));
          const s = document.createElement('span');
          s.className = 'brand-case';
          s.textContent = BRAND_CANON[m[1].toLowerCase()];
          frag.append(s);
          last = m.index + m[0].length;
        }
        frag.append(node.nodeValue.slice(last));
        node.replaceWith(frag);
      });
    });
  }
  brandCase();
  document.addEventListener('shopify:section:load', event => brandCase(event.target));

  /* ---------- word-by-word pop reveal: <p data-words> ---------- */
  function setupWordReveal(scope = document) {
    qsa('[data-words]', scope).forEach(el => {
      if (el.dataset.wordsBound === 'true') return;
      el.dataset.wordsBound = 'true';
      const words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach((word, i) => {
        const span = document.createElement('span');
        span.className = 'word';
        span.textContent = word.replace(BRAND_RE, m => BRAND_CANON[m.toLowerCase()]);
        BRAND_RE.lastIndex = 0;
        if (BRAND_RE.test(word)) span.classList.add('brand-case');
        BRAND_RE.lastIndex = 0;
        span.style.transitionDelay = `${i * 55}ms`;
        el.append(span, document.createTextNode(' '));
      });
      new IntersectionObserver((entries, obs) => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        el.classList.add('is-lit');
        obs.unobserve(el);
      }), { threshold: .25 }).observe(el);
    });
  }
  setupWordReveal();

  /* ---------- lazy YouTube facades: [data-youtube="ID"] ---------- */
  function setupYouTube(scope = document) {
    qsa('[data-youtube]', scope).forEach(el => {
      if (el.dataset.ytBound === 'true') return;
      el.dataset.ytBound = 'true';
      /* maxresdefault 404s for some videos (YouTube serves a tiny grey placeholder
         that Chrome renders) — detect by size and fall back to hqdefault */
      const thumb = el.querySelector('img');
      if (thumb && thumb.src.includes('maxresdefault')) {
        const fix = () => {
          if (thumb.naturalWidth && thumb.naturalWidth < 320) thumb.src = thumb.src.replace('maxresdefault', 'hqdefault');
        };
        thumb.complete ? fix() : thumb.addEventListener('load', fix);
      }
      el.addEventListener('click', () => {
        const id = el.dataset.youtube;
        if (!id) return;
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&playsinline=1`;
        frame.title = el.dataset.youtubeTitle || 'abcoffee video';
        frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        frame.allowFullscreen = true;
        frame.loading = 'lazy';
        el.classList.add('is-playing');
        el.replaceChildren(frame);
      });
    });
  }
  setupYouTube();

  /* ---------- horizontal story rails: [data-rail] + [data-rail-next/prev] ---------- */
  function setupRails(scope = document) {
    qsa('[data-rail]', scope).forEach(rail => {
      if (rail.dataset.railBound === 'true') return;
      rail.dataset.railBound = 'true';
      const wrap = rail.closest('[data-rail-scope]') || rail.parentElement;
      const step = () => (rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth * .85) + 20;
      wrap?.querySelector('[data-rail-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      wrap?.querySelector('[data-rail-next]')?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));

      /* Cursor becomes a left/right arrow depending on which half of the rail
         you hover; a click scrolls one card in that direction (13/08 feedback). */
      if (rail.hasAttribute('data-rail-cursor')) {
        const arrow = dir => 'url("data:image/svg+xml;utf8,' + encodeURIComponent(
          '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><circle cx="24" cy="24" r="23" fill="#0a0a0a"/><path d="M' +
          (dir < 0 ? '28 14l-10 10 10 10' : '20 14l10 10-10 10') +
          '" stroke="#C9DB42" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        ) + '") 24 24, pointer';
        let side = 0;
        rail.addEventListener('mousemove', e => {
          const r = rail.getBoundingClientRect();
          const next = e.clientX < r.left + r.width / 2 ? -1 : 1;
          if (next !== side) { side = next; rail.style.cursor = arrow(next); }
        });
        rail.addEventListener('mouseleave', () => { side = 0; rail.style.cursor = ''; });
        rail.addEventListener('click', e => {
          if (e.target.closest('a, button')) return;
          rail.scrollBy({ left: side < 0 ? -step() : step(), behavior: 'smooth' });
        });
      }
    });
  }
  setupRails();

  document.addEventListener('shopify:section:load', event => {
    setupWordReveal(event.target);
    setupYouTube(event.target);
    setupRails(event.target);
  });

  /* ---------- product page: per-option variant picker ---------- */
  qsa('[data-product-options]').forEach(wrap => {
    const form = wrap.closest('form');
    if (!form) return;
    const dataEl = form.querySelector('[data-variant-data]');
    const idInput = form.querySelector('[data-variant-id]');
    if (!dataEl || !idInput) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const selects = qsa('[data-product-option]', wrap);
    const priceEl = qs('[data-product-price]');
    const addBtn = form.querySelector('.buy-row__add');

    const apply = () => {
      const chosen = selects.map(s => s.value);
      const match = variants.find(v => v.options.every((o, i) => o === chosen[i]));
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = (match.compare_at > match.price ? '<span class="price price--sale"><s class="price__compare">₹' + Math.round(match.compare_at / 100) + '</s> <b class="price__now">₹' + Math.round(match.price / 100) + '</b></span>' : '<b class="price__now">₹' + Math.round(match.price / 100) + '</b>');
      if (addBtn) {
        addBtn.disabled = !match.available;
        const label = addBtn.childNodes[0];
        if (label && label.nodeType === 3) label.nodeValue = match.available ? 'Add to cart' : 'Sold out';
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url);
    };
    selects.forEach(s => s.addEventListener('change', apply));
    apply();
  });

  /* ---------- BAG: real Shopify cart via AJAX ---------- */
  const bagEl = qs('.bag'), scrim = qs('.bag-scrim');
  const money = cents => '₹' + (cents / 100).toLocaleString('en-IN');

  function renderBag(cart) {
    qsa('[data-bag-count]').forEach(n => {
      n.textContent = cart.item_count;
      n.classList.toggle('is-empty', !cart.item_count);
    });
    const totalEl = qs('[data-bag-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
    const itemsEl = qs('.bag__items');
    if (!itemsEl) return;
    const trash = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M10 4.5h4M9.5 7.5v10M14.5 7.5v10M6 7l1 12.2A2 2 0 0 0 9 21h6a2 2 0 0 0 2-1.8L18 7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    itemsEl.innerHTML = cart.item_count
      ? cart.items.map(item => `<article class="bag-item"><div><h3>${item.product_title}</h3><b>${money(item.final_line_price)}</b></div><div class="bag-item__actions"><div class="qty-pill"><button type="button" data-line-key="${item.key}" data-line-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-line-key="${item.key}" data-line-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button></div><button class="icon-delete" data-remove-key="${item.key}" aria-label="Remove item">${trash}</button></div></article>`).join('')
      : '<div class="bag-empty-wrap"><a class="bag-explore" href="/collections/all">EXPLORE NOW <span>→</span></a></div>';
    bindLineControls();
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
    renderBag(await res.json());
  }

  function bindLineControls() {
    qsa('[data-remove-key]').forEach(b => b.onclick = () => changeLine(b.dataset.removeKey, 0));
    qsa('[data-line-key]').forEach(b => b.onclick = () => changeLine(b.dataset.lineKey, +b.dataset.lineQty));
  }
  bindLineControls();

  function openBag(on = true) {
    bagEl?.classList.toggle('is-open', on);
    scrim?.classList.toggle('is-open', on);
    bagEl?.setAttribute('aria-hidden', String(!on));
    document.body.classList.toggle('locked', on);
  }
  qs('.bag-button')?.addEventListener('click', () => openBag());
  qs('.bag-close')?.addEventListener('click', () => openBag(false));
  scrim?.addEventListener('click', () => openBag(false));

  /* add-to-cart: <button data-add-variant="123"> (real) or data-add (visual demo only) */
  qsa('[data-add-variant]').forEach(btn => btn.addEventListener('click', async () => {
    const old = btn.innerHTML;
    btn.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: +btn.dataset.addVariant, quantity: 1 })
      });
      const cart = await (await fetch('/cart.js')).json();
      renderBag(cart);
      btn.innerHTML = 'Added ✓';
      openBag();
    } catch (e) {
      btn.innerHTML = 'Error';
    }
    setTimeout(() => { btn.innerHTML = old; btn.disabled = false; }, 1000);
  }));
})();

/* Phone arrows under the horizontal rails (partnerships, why absub). */
(() => {
  document.querySelectorAll('.cpar__rail, .af-why__rail').forEach(rail => {
    const nav = document.createElement('div'); nav.className = 'rail-nav';
    const mk = (dir, label) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'rail-nav__btn'; b.setAttribute('aria-label', label);
      b.innerHTML = dir < 0 ? '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', () => { const card = rail.firstElementChild; const step = card ? card.getBoundingClientRect().width + 14 : rail.clientWidth * 0.8; rail.scrollBy({ left: dir * step, behavior: 'smooth' }); });
      return b; };
    nav.append(mk(-1, 'Previous'), mk(1, 'Next'));
    rail.insertAdjacentElement('afterend', nav);
  });
})();
